import React from "react";

export function AddIcon() {
  return <i className="fas fa-plus"></i>;
}
